export default {
  init() {
    // JavaScript to be fired on all pages
    let contador = 0;
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      if(contador == 0 ) {
        $('.menuMovil').animate({
          'display': 'block',
          'left': '0',
        }, 500);
        contador = 1;
      } else {
        $('.menuMovil').animate({
          'display': 'block',
          'left': '-100vw',
        }, 500);
        contador = 0;
      }
    });

    $(window).on('scroll', function(){
      if ( $(window).scrollTop() > altura ){
        // crearDivMenu();
        $('header').addClass('menu-fixed');
        $('.promo-header').css('display','none');
        $('.top-header').css('display','none');

      } else {
        $('.banner').removeClass('menu-fixed');
        $('.promo-header').css('display','block');
        $('.top-header').css('display','block');

      }
    });

    // let miVr = document.title;
    var altura = $('.banner').offset().top;
    // let contadorBotones = 0;
    // function crearDivMenu(){
    //   if(contadorBotones == 0) {
    //     $('#menu-menu-principal .btntTaatroMenu').after($('.brand'));
    //     contadorBotones = 1;
    //   }
    // }





    // if ( miVr === 'MAMMA MIA! El Musical – Teatro Rialto, Madrid') {
    //   crearDivMenu();
    // } else {
    //   $('.brand').css('display','block');
    //   $('.navbar-nav').css({
    //     'right' : '15px',
    //     'justify-content' : 'space-around',
    //     'width' : '100%',
    //   });
    //   crearDivMenu();
    // }




    // $(window).on('scroll', function(){
    //     if(document.title != 'MAMMA MIA! El Musical - Teatro Rialto, Madrid') {
    //       if ($(window).scrollTop() > altura) {
    //         $('.banner').addClass('menu-fixed');
            
    //       } else {
    //         $('.banner').removeClass('menu-fixed');
           
    //       }
    //     }
    // });

    let prevUrl = document.referrer;

   
    console.log(prevUrl);

      $('a[href*=#]').click(function() {
        let varAlturaMenu = $('.banner').height();
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
        && location.hostname == this.hostname) {
          var $target = $(this.hash);
          $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
          if ($target.length) {
            var targetOffset = $target.offset().top - varAlturaMenu;
            console.log(targetOffset);
            $('html,body').animate({scrollTop: targetOffset}, 800);
            return false;
          }
        }
      });
      

       // Obtener todas las imágenes en la página
 const images = document.querySelectorAll('img');

 images.forEach(function(image) {
     // Verificar si el atributo 'alt' está vacío o no existe
     if (!image.hasAttribute('alt') || image.alt.trim() === '') {
         // Obtener el título de la página
         const pageTitle = document.title || 'Título de la página';

         // Obtener el nombre del archivo de la imagen sin la extensión
         const imageUrl = image.src;
         const imageName = imageUrl.split('/').pop().split('.')[0];

         // Asignar el nuevo atributo 'alt' con el formato: "Título - NombreArchivo"
         image.setAttribute('alt', `${pageTitle} - ${imageName}`);
     }
 });

 var campoNombre = document.querySelector('input[name="nombre"]');
    var campoEmail = document.querySelector('input[name="email"]');
    var campoCheck = document.querySelector('input[name="terms"]');
    // Verifica si el campo existe y añade el atributo aria-label
    if (campoNombre) {
        campoNombre.setAttribute('aria-label', 'Nombre completo');
    }
    if (campoCheck) {
      campoCheck.setAttribute('aria-label', 'Acepta condiciones');
  }
    
    if (campoEmail) {
        campoEmail.setAttribute('aria-label', 'Introduce aqui el Correo electrónico');
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js